<script setup>
import { computed } from 'vue';

const props = defineProps({
  reactions: {
    type: Array,
    default: () => [],
  },
});

const groupedReactions = computed(() => {
  const groups = {};
  props.reactions.forEach(reaction => {
    const emoji = reaction.emoji;
    if (!groups[emoji]) {
      groups[emoji] = { emoji, count: 0, senders: [] };
    }
    groups[emoji].count += 1;
    if (reaction.sender_name) {
      groups[emoji].senders.push(reaction.sender_name);
    }
  });
  return Object.values(groups);
});
</script>

<template>
  <div v-if="reactions.length > 0" class="flex flex-wrap gap-1 mt-1">
    <div
      v-for="group in groupedReactions"
      :key="group.emoji"
      class="inline-flex items-center gap-0.5 px-1.5 py-0.5 text-xs rounded-full bg-n-alpha-2 hover:bg-n-alpha-3 cursor-default"
      :title="group.senders.join(', ')"
    >
      <span>{{ group.emoji }}</span>
      <span v-if="group.count > 1" class="text-n-slate-11">{{
        group.count
      }}</span>
    </div>
  </div>
</template>
